@if (modelArray.length) {
@for (item of modelArray; track item.id) {
@switch (item?.data && item?.type) {
@case ('page') {
<page-view [model]="getModelAsCmsPage()" />
}
@case ('category') {
@let model = getModelAsCategory();
@if (model.data?.pageTemplate === 'giftcards') {
<giftcards-category-view [model]="model" />
} @else {
<category-view [model]="model" />
}
}
@case ('product') {
<product-layout-view [model]="getModelAsProduct()" />
}
@case ('store') {
<store-view [model]="getModelAsStore()" />
}
@default {
<error-404 />
}
}
}
}